import doc                      from 'decorators/doc';
import model                    from 'decorators/model';
import { Timestampable }        from 'helpers/traits';
import { Blamable }             from 'helpers/traits';
import DirectoryPrivateApiModel from 'modelx/models/abstracts/DirectoryPrivateApiModel';

@model.cacheDuration()
@model.staticLabel('EnterpriseProperty')
@model.urnResource('enterprise_property')
@doc.path('/enterprise_properties/{?id}')
export default class EnterprisePropertyModel extends Blamable(Timestampable(DirectoryPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'isUnique': '0' | '1';
		'reference': DirectoryEnterprisePropertyReference;
		'type': id;
	}> = {};

	public _sorts: ModelSortsExtended<unknown> = {};

	@doc.boolean declare isUnique: boolean;
	@doc.string declare label: string;
	@doc.string declare reference: DirectoryEnterprisePropertyReference;
	@doc.boolean declare unique: boolean;
	@doc.string declare type: string;
}